import { Star, Quote } from 'lucide-react';

const testimonials = [
  {
    id: 1,
    name: 'Sarah M.',
    location: 'Goodyear, AZ',
    text: "Ted's team was incredible! They helped us choose the perfect shutters for our new home. Professional, punctual, and the quality exceeded our expectations.",
    rating: 5,
  },
  {
    id: 2,
    name: 'Michael R.',
    location: 'Buckeye, AZ',
    text: 'Best experience with any home improvement company. Fair pricing, no pressure sales, and beautiful Roman shades that transformed our living room.',
    rating: 5,
  },
  {
    id: 3,
    name: 'Jennifer L.',
    location: 'Glendale, AZ',
    text: "We've used Ted's for three different homes now. Consistent quality and service every time. Highly recommend for any window treatment needs!",
    rating: 5,
  },
];

export function Testimonials() {
  return (
    <section className="py-20 md:py-28 bg-primary text-primary-foreground">
      <div className="container-custom">
        {/* Section Header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <span className="inline-block px-4 py-1.5 bg-primary-foreground/10 text-primary-foreground rounded-full text-sm font-medium mb-4">
            Testimonials
          </span>
          <h2 className="font-display text-3xl md:text-4xl lg:text-5xl font-bold mb-6">
            What Our Customers Say
          </h2>
          <p className="text-lg text-primary-foreground/80">
            Don't just take our word for it. Here's what Phoenix homeowners have to say about working with Ted's Shades and Shutters.
          </p>
        </div>

        {/* Testimonials Grid */}
        <div className="grid md:grid-cols-3 gap-8">
          {testimonials.map((testimonial) => (
            <article
              key={testimonial.id}
              className="bg-primary-foreground/5 backdrop-blur-sm rounded-xl p-8 relative"
            >
              <Quote className="absolute top-6 right-6 w-10 h-10 text-primary-foreground/10" />
              
              {/* Rating */}
              <div className="flex gap-1 mb-4">
                {Array.from({ length: testimonial.rating }).map((_, i) => (
                  <Star key={i} className="w-5 h-5 fill-gold text-gold" />
                ))}
              </div>
              
              <p className="text-primary-foreground/90 leading-relaxed mb-6">
                "{testimonial.text}"
              </p>
              
              <footer>
                <div className="font-semibold">{testimonial.name}</div>
                <div className="text-sm text-primary-foreground/60">{testimonial.location}</div>
              </footer>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
